export const CIRCLE_SIZE = 170;
export const CIRCLE_POSITION = 85; // CIRCLE_SIZE / 2
export const CIRCLE_RADIUS = 68; // CIRCLE_SIZE / 2.5
export const CIRCLE_LENGTH = 427; // 2 * Math.PI * CIRCLE_RADIUS
export const STROKE_WIDTH = 11; // 2 * Math.PI * CIRCLE_RADIUS
